"use strict";
var Observable_1 = require("../../Observable");
var throttleTime_1 = require("../../operator/throttleTime");
Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
//# sourceMappingURL=throttleTime.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/throttleTime.js
 ** module id = 420
 ** module chunks = 1
 **/